import { IHisRegistry, IHisInformationRepository } from "../../../domain/his";
import { HisInformationRepository } from "./HisInformationRepository";

export class HisRegistry implements IHisRegistry {
  constructor(private _getToken: () => string) {
  }

  getHisInformationRepository(): IHisInformationRepository {
    return new HisInformationRepository(this._getToken);
  }
}
